module.exports = __webpack_public_path__ + "static/media/popup3.bf56998b.svg";